import React from 'react';
import logo from '../assets/images/logo2.png';

const Footer = () => {
  return (
    <>
      <footer className="bg-gray-200 text-gray-700 py-12">
        <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-8 text-center md:text-left">
          <div className="space-y-4 flex flex-col items-center md:items-start">
            <img src={logo} alt="Bitdeploy Logo" className="h-16 w-auto" />
            <p className="text-sm">Your trusted partner for IT infrastructure and secure data destruction services.</p>
          </div>
          <div>
            <h3 className="font-bold uppercase mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#home" className="hover:text-blue-600">Home</a></li>
              <li><a href="#about" className="hover:text-blue-600">About Us</a></li>
              <li><a href="#services" className="hover:text-blue-600">Services</a></li>
              <li><a href="#shredding" className="hover:text-blue-600">Secure Shredding</a></li>
              <li><a href="#contact" className="hover:text-blue-600">Contact Us</a></li>
              <li><a href="/privacy-policy" target='_blank' className="hover:text-blue-600">Privacy Policy</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold uppercase mb-4">Our Services</h3>
            {/* --- THIS SECTION HAS BEEN UPDATED --- */}
            <ul className="space-y-2">
                <li><a href="#services" className="hover:text-blue-600">Network & Cabling</a></li>
                <li><a href="#services" className="hover:text-blue-600">Wireless Solutions</a></li>
                <li><a href="#services" className="hover:text-blue-600">Security & CCTV</a></li>
                <li><a href="#services" className="hover:text-blue-600">Phone & VOIP Systems</a></li>
                <li><a href="#shredding" className="hover:text-blue-600">Secure Data Shredding</a></li>
            </ul>
          </div>
          <div>
            <h3 className="font-bold uppercase mb-4">Contact Info</h3>
            <ul className="space-y-2 text-sm">
                <li>Alberta, BC, Saskatchewan</li>
                <li><a href="mailto:info@bitdeploy.ca" className="hover:text-blue-600">info@bitdeploy.ca</a></li>
                <li><a href="tel:+14037154039" className="hover:text-blue-600">+1(403)715-4039</a></li>
            </ul>
          </div>
        </div>
      </footer>
      <div className="bg-gray-800 text-white text-center py-4">
        <p>&copy; {new Date().getFullYear()} Bitdeploy. All Rights Reserved.</p>
      </div>
    </>
  );
};

export default Footer;